import { useState } from 'react';
import { motion } from 'framer-motion';
import LogoMark from './LogoMark';

export default function AnimationLogo({
  stepDuration = 350,
  delay = 0.5,
  size = 320,
  bgColor = '#080808',
  logoColor = '#ffffff',
  cutColor = '#000000',
  onBuildComplete,
}) {
  const [isComplete, setIsComplete] = useState(false);

  return (
    <div
      style={{
        width: '100%',
        background: bgColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 0,
          opacity: 0.025,
          backgroundImage:
            'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />

      <motion.div
        animate={isComplete ? { y: [-4, 0, -4] } : { y: 0 }}
        transition={isComplete ? { duration: 4, repeat: Infinity, ease: 'easeInOut' } : {}}
        style={{ zIndex: 2 }}
      >
        <motion.div
          animate={isComplete ? { scale: [1, 1.03, 1] } : { scale: 1 }}
          transition={isComplete ? { duration: 0.8, ease: 'easeOut' } : {}}
        >
          <LogoMark
            size={size}
            logoColor={logoColor}
            cutColor={cutColor}
            stepDuration={stepDuration}
            delay={delay}
            onBuildComplete={() => {
              setIsComplete(true);
              onBuildComplete?.();
            }}
          />
        </motion.div>
      </motion.div>
    </div>
  );
}
